export const underwritingTabStyles = {
  dataGrid: {
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto',
    },
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dataGridContainer: {
    flex: 1,
    minHeight: 0,
  },
  activityPanel: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  tableWrapper: {
    flex: 1,
    minHeight: 0,
  },
  buttonContainer: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 2,
  },
};
